import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Card, Form } from "react-bootstrap";
import { useAlert } from "../../../../context/AlertContext";
import { ExcelIcon, CalendarIcon } from "../../../../data/iconImage";
import ButtonOptionSubmenu from "../../../../components/ButtonOptionSubmenu";
import SearchFilter from "../../../../components/SearchFilter";
import Table from "../../../../components/Table";
import ButtonLink from "../../../../components/ButtonLink";
import {
  getServiceRequest,
  addEditServiceRequest,
  deleteServiceRequest
} from "../../../../commons/ServiceRequest";
import TechnicianPlansService from "../../../../services/technicianplan.service";
import {
  emptyValueObjects,
  filteredCreateNewKey,
  findItemInArray,
  hasDuplicateValues,
  filteredItemInArray
} from "../../../../utils/ManageArray";
import { formatInputDate, toFormatISO } from "../../../../utils/Time";
import { formatDate } from "../../../../commons/FormatValue";
import { initializeSetOption } from "../../../../utils/InitializeSetDefault";
import PropTypes from "prop-types";
import InputSearch from "../../../../components/InputSearhComponent";
import { getQueryString } from "../../../../utils/Query";
import TableForm2s from "../../../../components/TableFormScrb";
import CustomersService from "../../../../services/customer.service";
import TechnicianReceiveService from "../../../../services/technicianreceive.service";
import moment from "moment";

export default function EventPlanningDetail({ initialData }) {
  const navigate = useNavigate();
  const { showAlert } = useAlert();
  const { state } = useLocation();
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [data, setData] = useState([]);
  const [mainData, setMainData] = useState([]);
  const [searchValue, setSearchValue] = useState([]);
  const [seqNo, setSeqNo] = useState([]);
  const [validated, setValidated] = useState(false);
  const [customerCode, setCustomerCode] = useState([]);
  const [customerName, setCustomerName] = useState([]);
  const [pagination, setPagination] = useState({});
  const [querySearch, setQuerySearch] = useState()
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const [currentPage, setCurrentPage] = useState(1);

  const searchInput = [
    {
      name: "sup_team",
      label: "ชื่อทีม/หัวหน้าช่าง",
      classNames: { label: "mb-3" },
      type: "text",
      disabled: true,
      size: 3
    },
    {
      name: "Tech_Doc_Date",
      label: "วันที่วางแผน",
      //value: currentDate,
      classNames: { label: "mb-3" },
      type: "date",
      size: 3
    },
    // {
    //   name: "Tech_Doc_No",
    //   label: "เลขที่วางแผน",
    //   classNames: { label: "mb-3" },
    //   size: 3,
    //   required: true,
    //   noneAsync: true,
    //   filterBy: ["Tech_Doc_No"],
    //   options: initializeSetOption({
    //     key: "Id",
    //     label: "Tech_Doc_No",
    //     dataset: filteredItemInArray(
    //       data,
    //       "Tech_Doc_No",
    //       data.Tech_Doc_No
    //     )
    //   })
    // },
    {
      name: "seqNo",
      label: "เลขที่ใบสั่งงาน",
      classNames: { label: "mb-3" },
      size: 3,
      // filterBy: ["Seq_Oth_No"],
      options: initializeSetOption({
        key: "Seq_no",
        label: "Seq_no",
        dataset: seqNo
      }),
      queryService: (query, value) => {
        const q = ({ seq_no: value, plan_status: "OPEN", limit: 100, page: 1 })
        setQuerySearch(q)
        getServiceRequest({
          showAlert,
          setLoading: () => { },
          serviceRequest: TechnicianReceiveService.getSeqNo(getQueryString(q)),
          callback: (array) => {
            const newArray = array.map(arr => ({
              Seq_no: arr.seqJob.seqNo
            }))
            setSeqNo(newArray)
          }
        });
      }
    },
    {
      name: "jobTypeId",
      label: "ประเภทงาน",
      classNames: { label: "mb-3" },
      size: 3,
      noneAsync: true,
      filterBy: ["Job_Type_Name"],
      options: initializeSetOption({
        key: "Id",
        label: "Job_Type_Name",
        dataset: initialData?.jobTypes
      })
    },
    {
      name: "seqStatusId",
      label: "สถานะใบสั่งงาน",
      classNames: { label: "mb-3" },
      size: 3,
      noneAsync: true,
      filterBy: ["Seq_St_Name"],
      options: initializeSetOption({
        key: "Id",
        label: "Seq_St_Name",
        dataset: initialData?.seqStatus
      })
    },
    {
      name: "cusCode",
      label: "รหัสลูกค้า/สาขา",
      classNames: { label: "mb-3" },
      size: 3,
      filterBy: ["Cus_Code"],
      options: initializeSetOption({
        key: "Cus_Code",
        label: "Cus_Code",
        dataset: customerCode
      }),
      queryService: (query) => {
        getServiceRequest({
          showAlert,
          setLoading: () => { },
          serviceRequest: CustomersService.getAllCustomers(query),
          callback: ({ items }) => setCustomerCode(items)
        });
      }
    },
    {
      name: "cusName",
      label: "ชื่อลูกค้า/สาขา",
      classNames: { label: "mb-3" },
      size: 6,
      filterBy: ["Cus_Name"],
      options: initializeSetOption({
        key: "Cus_Name",
        label: "Cus_Name",
        dataset: customerName
      }),
      queryService: (query) => {
        getServiceRequest({
          showAlert,
          setLoading: () => { },
          serviceRequest: CustomersService.getAllCustomers(query),
          callback: ({ items }) => setCustomerName(items)
        });
      }
    }
  ];
  const columns = [
    {
      name: "JobType",
      label: "ประเภทงาน",
      readOnly: true,

      // format: (row) => JobType.find(item => item.Id === row.Job_Type_Id)?.Job_Type_Name,
      width: "180px"
    },
    {
      name: "Seq_No",
      label: "เลขที่ใบสั่งงาน",
      readOnly: true,
      // inputClass: "text-success",
      // onClick: (row) => navigate(`/service_work/perform/${row.Seq_No}`, {
      //   state: { name: "ServiceReq", data: row }
      // }),
      width: "180px"
    },
    {
      name: "Cus_Code",
      label: "รหัสลูกค้า/สาขา",
      readOnly: true,
      width: "180px"
    },
    {
      name: "Cus_Name",
      label: "ชื่อลูกค้า/สาขา",
      readOnly: true,
      width: "250px",
      showTooltip: true
    },
    // {
    //   name: "",
    //   label: "รายละเอียดสินค้า",
    //   type: "text",
    //   readOnly: true,
    //   width: "200px"
    // },

    {
      name: "Job_Start_Date",
      label: "วันที่เข้างานระหว่าง",
      readOnly: true,
      format: (row) => formatDate(row.Job_Start_Date)
    },
    {
      name: "Job_End_Date",
      label: "ถึงวันที่",
      readOnly: true,
      format: (row) => formatDate(row.Job_End_Date)
    },
    {
      name: "Job_Actual_Date",
      label: "วันที่เข้างานจริง",
      readOnly: true,
      format: (row) => formatDate(row.Job_Actual_Date)
    },
    {
      name: "Tech_Mas_Name",
      label: "ช่างผู้ปฏิบัติงาน",
      readOnly: true,
      width: "200px",
      showTooltip: true
    },
    {
      name: "Job_Status",
      label: "สถานะงานช่าง",
      readOnly: true,
      showTooltip: true
    },
    {
      name: "Reject_Reason",
      label: "เหตุผลไม่รับงาน",
      width: "180px",
      readOnly: true,
      showTooltip: true
    },
    {
      name: "Seq_Status_Name",
      label: "สถานะใบสั่งงาน",
      readOnly: true,
    },
    {
      label: "",
      type: "activeButton"
    }
  ];

  const filteredArray = (Id) => {
    return mainData.filter((item) => item.Id === Id);
  };

  const handleValidated = (event) => {
    event.preventDefault();
    const form = event.currentTarget;

    if (!form.checkValidity()) {
      event.stopPropagation();
      setValidated(true);
    } else {
      setShowModal(true);
    }
  };

  useEffect(() => {
    //setDataTable(data);
    setSearchValue([]);
  }, [data]);

  const handleSubmitDelete = async (event, dataCallback) => {
    event.preventDefault();

    if (dataCallback && dataCallback.Plan_Status == "OPEN") {
      await handleSubmitPlanDel(dataCallback.Id);

      // getMainData();
      setSearchValue([]);
    }
  };

  const deleteTechPlan = async (event, dataCallback) => {
    event.preventDefault()

    deleteServiceRequest({
      showAlert,
      setLoading: () => { },
      serviceRequest: TechnicianPlansService.deleteTechnicianPlans(dataCallback?.Id, true),
      refreshRequest: getTechnicianPlanningBy({
        page: 1,
        limit: rowsPerPage
      }),
      // callback: (res) => setData(res)
    });
    setSearchValue([]);
  };

  const handleSearchFilter = (search) => {
    const newSearch = filteredCreateNewKey({
      data: data,
      search: search,
      newName: ["Id"]
    });

    let filteredData = data.filter((item) =>
      newSearch.some(({ name, value }) => item[name] === value)
    );

    filteredData = filteredData.map(({ ...item }) => ({ ...item }));
    setSearchValue(search.length !== 0 ? filteredData : []);
  };
  const handleSearchCallback = (search) => {
    if (!search) {
      setData([])
      return
    }
    getTechnicianPlanningBy({
      ...search,
      start: toFormatISO(search.Tech_Doc_Date),
      // end: toFormatISO(search?.Tech_Doc_Date && moment(new Date(search.Tech_Doc_Date)).add(1, 'days')),
      end: toFormatISO(search?.Tech_Doc_Date),
      page: 1,
      limit: rowsPerPage
    });
  };

  const getTechnicianPlanningBy = (query) => {
    setQuerySearch(query)
    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: TechnicianPlansService.getTechnicianPlanning(
        getQueryString(query)
      ),
      callback: (res) => {
        setPagination({
          ...res?.pagination,
          dataCount: res?.dataCount,
          allCount: res?.allCount
        });
        // res?.data?.map((item) => {console.log(item)})
        setData(
          res?.data?.map((item) => {
            return {
              ...item,
              Id: item.id,
              JobType:
                item?.SeqOthersJob?.JobType?.Job_Type_Name ||
                item?.SeqInstalljob?.JobTypes?.Job_Type_Name ||
                item?.RepairJobs?.JobType?.Job_Type_Name,
              Seq_No:
                item?.SeqOthersJob?.Seq_Oth_No ||
                item?.SeqInstalljob?.seq_install_no ||
                item?.RepairJobs?.seq_repair_no,
              Cus_Code:
                item?.SeqOthersJob?.InformOtherJob?.Customer?.Cus_Code ||
                item?.SeqInstalljob?.InformInstallJobs?.BPCustomer?.Cus_Code ||
                item?.RepairJobs?.informRepairJob?.concern_customer_items
                  ?.Cus_Code,
              Cus_Name:
                item?.SeqOthersJob?.InformOtherJob?.Customer?.Cus_Name ||
                item?.SeqInstalljob?.InformInstallJobs?.BPCustomer?.Cus_Name ||
                item?.RepairJobs?.informRepairJob?.concern_customer_items
                  ?.Cus_Name,
              Job_Cus_Date: item?.InformInstallJobs?.Job_Cus_Date,
              Job_Start_Date: formatInputDate(
                item.SeqInstalljob?.job_start_date ||
                item.RepairJobs?.job_start_date

                , "Local").date,
              Job_End_Date: formatInputDate(
                item.SeqInstalljob?.job_end_date ||
                item.RepairJobs?.job_end_date

                , "Local").date,
              Job_Actual_Date: item?.job_actual_date,
              Job_Status:
                item?.DepartJob?.Depart_St_Name,
              Reject_Reason: item.TechnicianReceive.length
                ? item.TechnicianReceive[0]?.reject_reason : "",
              Tech_Mas_Name: item?.Technician?.Tech_Mas_Name,
              Seq_Status_Name: initialData?.seqStatus.find(el => el.Id ==
                item?.RepairJobs?.seq_status_id ||
                item?.SeqOthersJob?.Seq_Status_Id ||
                item?.SeqInstalljob?.seq_status_id
              )?.Seq_St_Name,
              // Seq_Status_Id: item?.RepairJobs?.seq_status_id,
              Contract_No: item?.SeqInstalljob?.InformInstallJobs?.Contract_No
                || item?.SeqOthersJob?.InformOtherJob?.Contract_No
                || item?.RepairJobs?.informRepairJob?.Contract_No

            };
          })
        );
      }
    });
  };
  return (
    <>
      <Card className="m-1 mb-4 p-4 border-0">
        <Card.Header
          className="bg-transparent border-0 text-center"
          style={{ fontSize: "24px" }}
        >
          ข้อมูลการวางแผน
        </Card.Header>
        <Card.Body>
          <InputSearch
            inputField={searchInput}
            field={searchInput}
            searchCallback={handleSearchCallback}
          />
        </Card.Body>
      </Card>
      {/* <Card.Body>
          <SearchFilter
            data={data}
            inputField={searchInput}
            fieldClassName={{
              inputRow: "justify-content-end align-items-center",
              actionButton: "w-auto py-2"
            }}
            //searchCallback={(search) => setSearchValue(search)}
            searchCallback={handleSearchFilter}
            // moreButton={
            //   <>
            //     <ButtonLink
            //       linkTo="import"
            //       stateData={{ name: "EventPlanning" }}
            //       buttonClass="me-2 py-2 px-4 text-dark rounded-pill"
            //       buttonName="นำเข้าไฟล์ .xlsx"
            //       iconSrc={ExcelIcon}
            //       iconClass="me-2"
            //       iconName="Excel Icon"
            //     />
            //   </>
            // }
          />
        </Card.Body> */}
      <Form noValidate >
        <Card className="m-1 mb-4 p-4 border-0">
          <Card.Header className="p-3 d-flex justify-content-between align-items-center border-bottom-0 bg-transparent">
            <Card.Title className="mb-0 fs-2 text-dark">
              รายละเอียดงาน
            </Card.Title>
          </Card.Header>

          <Card.Body>
            <TableForm2s
              data={data}
              columns={columns}
              isLoading={loading}
              searchFilter={searchValue}
              pagination
              rowsPerPage={rowsPerPage}
              currentPage={pagination?.page}
              rowCount={pagination?.allCount}
              previewButton={{
                link: "preview",
                // state: ""
              }}
              editButton
              deleteButton
              onDeleteCallback={deleteTechPlan}
              fetchData={pag => {
                if (pag?.limit) setRowsPerPage(pag.limit)
                getTechnicianPlanningBy({
                  ...querySearch,
                  page: pag.page,
                  limit: pag?.limit || rowsPerPage
                });
              }}
            />
          </Card.Body>
        </Card>
      </Form>
    </>
  );
}

EventPlanningDetail.propTypes = {
  initialData: PropTypes.object
};
